import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiContainer } from '@splashthat/sui';

import BackButton from 'common/compounds/BackButton';

import { WorkspaceTopbar } from '../Topbar';
import WorkspaceContent from '../Content';
import FullScreenPreview from './FullScreenPreview';

export default class WorkspacePreview extends Component {
    baseClassName = 'WorkspacePreview';

    static FullScreenPreview = FullScreenPreview;

    static propTypes = {
        title: PropTypes.string.isRequired,
        children: PropTypes.node.isRequired,
        fallbackPath: PropTypes.string.isRequired,
        topbarRightContent: PropTypes.func,
    };

    static defaultProps = {
        topbarRightContent: null,
    };

    render() {
        const { topbarRightContent } = this.props;

        return (
            <React.Fragment>
                <WorkspaceTopbar className={`${this.baseClassName}__topbar`} useLightMode>
                    <SuiContainer className={`${this.baseClassName}__topbar-container`} variation="flex-horizontal">
                        <SuiContainer variation="flex-horizontal">
                            <BackButton fallbackPath={this.props.fallbackPath} isDark />
                            <WorkspaceTopbar.Title title={this.props.title} />
                        </SuiContainer>
                        {topbarRightContent && topbarRightContent()}
                    </SuiContainer>
                </WorkspaceTopbar>
                <WorkspaceContent>{this.props.children}</WorkspaceContent>
            </React.Fragment>
        );
    }
}
